export default "__VITE_ASSET__CC3oOiMt__"